<template>
  <footer class="footer">
    <div class="inner">
      <el-link href="http://beian.miit.gov.cn">{{list.cName}}&nbsp;&nbsp;{{list.ICP}}</el-link>
      <!-- <p>{{list.serverPhone}}&nbsp;&nbsp;{{list.qyQQ}}&nbsp;&nbsp;{{list.Email}}</p> -->
    </div>
    <el-backtop :bottom="100">
      <div
        style="{
        height: 100%;
        width: 100%;
        background-color: rgb(243 144 7);
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #fff;
      }"
      >
        UP
      </div>
    </el-backtop>
  </footer>
</template>

<script>
export default {
  name: "CommonFoot",
  data () {
    return {
      list: {
        cName: 'BOOK KNOWLEDGE SEARCH (BKS)',
        ICP: '京ICP备2020036678号-1',
        // serverPhone: '服务热线:400-838-0150',
        // qyQQ: '企业QQ:400-838-0150',
        // Email: '邮箱:service@broadtop.cn',
      },
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/foot/Foot.vue